import React from "react";
import RentalTemplate from "../RentalCars/RentalTemplate";
import RentalUrl from "../RentalCars/RentalUrl"

export default class SeoOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
    this.layoutMobile = (typeof window !== 'undefined') && window.innerWidth < MAX_WIDTH;
  }

  next = () => {
    const nextIndex =
      this.state.activeIndex === this.props.list.length - 1
        ? 0
        : this.state.activeIndex + 1;
    this.setState({ activeIndex: nextIndex });
  };

  previous = () => {
    const nextIndex =
      this.state.activeIndex === 0
        ? this.props.list.length - 1
        : this.state.activeIndex - 1;
    this.setState({ activeIndex: nextIndex });
  };
  
  bookModel = (car) => {
    const r = this.props
    if (typeof window !== 'undefined') {
      window.location.href = '/rental_cars/' + car.offer_id + '/car_details?' +
          RentalUrl.searchQuery(r) + '&model=' + car.model_id
    }
  }

  renderItem = (item, active, index) => {
    return (
      <div key={index} className={'collapse' + (active ? ' show' : '')}>
        <RentalTemplate {...this.props} 
          book={this.bookModel} 
          offer={item.offer} 
          model={item.model} 
          qs={RentalUrl.searchQuery(this.props)} />
      </div>
    );
  };

  render() {
    const { activeIndex } = this.state;
    return (
      <div className="row">
        <div className="col-6 col-sm-1 d-flex align-self-center justify-content-center order-1">
          <i
            className="fa fa-chevron-left"
            onClick={this.previous}
            style={{ cursor: "pointer", fontSize: "20px", padding: "8px"  }}
          ></i>
        </div>
        <div className="col-12 col-sm-10 order-3 order-sm-2">
          {this.props.list.map((item, index) =>
            this.renderItem(item, activeIndex === index, index)
          )}
        </div>
        <div className="col-6 col-sm-1 d-flex align-self-center justify-content-center order-2 order-sm-3">
          <i
            className="fa fa-chevron-right"
            onClick={this.next}
            style={{ cursor: "pointer", fontSize: "20px", padding: "8px" }}
          ></i>
        </div>
      </div>
    );
  }
}
